export default {"src":"/_next/static/media/BackPain.672669fd.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};